export default __webpack_public_path__ + "static/img-1-2631dfe09bb15e7495c262c940dfd888.jpg";